import React from "react";
import styled from "styled-components";
import { SpecializationData } from "../../../data/Specialization";
// import LargeCard from "./LargeCard";
import {ProjectList } from "../../../data/ProjectData";
import MediumCard from "./../Release/MediumCard"
import SmallCard from "./../Projects/SmallCard";

// create css for the left of big card and right of big card
const Card = styled.div`
    display: grid;
    grid-gap: 2rem;
    margin-bottom: 4rem;
    grid-template-columns: 1fr;
    padding-bottom: 2rem;
    overflow: hidden;
    border-radius: 10px;
    background-color: #fff;

    @media (min-width: 992px) {
        grid-template-columns: 1fr 1fr;
        border-bottom: 0;
        padding-bottom: 0;
    }

    img {
        object-fit: cover;
    }

    h4 {
        font-size: 1.5rem;
        font-weight: 400;
        text-align: left; /* Move header to the right */
    }

    p {
        font-weight: 400;
        max-width: 100%;
        margin-top: 10px;
        margin-bottom: 1rem;
        color: rgba(0, 0, 0, 0.815);
        text-align: center; /* Center the description by default */

        @media (min-width: 992px) {
            text-align: left; /* Right align text for the left section */
        }
    }
`;

const CardLeft = styled.div`
    text-align: right; /* Align text to the right */
    height: 100%;
`;

const CardRight = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* Align items to the left */
    text-align: left; /* Align text to the left */
`;

function Specialization() {
  return (
    <>
      <div className="ProjectWrapper" id="specialization">
      <div className="Container">
                  <div className="SectionTitle">The Game Assembly</div>

        <SmallCard projects={ProjectList} />
      </div>

        <div className="Container">
          {/* <div className="SectionTitle">// Specialization</div> */}
            <div className="BigCard">
                <Card>

                {SpecializationData.map((list, index) => (
                    index % 2 === 0 ? (
                        <>
                        <CardLeft key={index}>
                            <img src={list.img} alt={list.title} />
                        </CardLeft>
                        <CardRight>
                            <h4><strong>{list.title}</strong></h4>
                            <p>{list.body}</p>
                            <p>{list.footer}</p>
                        </CardRight>
                        </>
                    ) : (
                        <>
                        <CardRight>
                            <h4><strong>{list.title}</strong></h4>
                            <p>{list.body}</p>
                            <p>{list.footer}</p>
                        </CardRight>
                        <CardLeft key={index}>
                            <img src={list.img} alt={list.title} />
                        </CardLeft>
                        </>
                    )
                    ))}

                </Card>
            </div>

        </div>
      </div>
    </>
  );
}

export default Specialization;
